const ADMIN_LIKE_PERMISSIONS = ['site_admin', 'developer']

function asArray(value) {
  if (Array.isArray(value)) return value
  if (typeof value === 'string') return [value]
  return []
}

export function toPermissionNames(userOrSessionUser) {
  const permissions = userOrSessionUser?.permissions
  if (!Array.isArray(permissions)) return []

  const names = permissions
    .map((permission) => {
      if (typeof permission === 'string') {
        return permission
      }
      if (permission && typeof permission.permissionName === 'string') {
        return permission.permissionName
      }
      return null
    })
    .filter((name) => typeof name === 'string' && name.length > 0)

  return [...new Set(names)]
}

export function hasAllPermissions(userOrSessionUser, requiredPermissions) {
  const required = asArray(requiredPermissions)
  if (required.length === 0) return true

  const names = toPermissionNames(userOrSessionUser)
  return required.every((requiredPermission) =>
    names.includes(requiredPermission),
  )
}

export function hasAnyPermission(userOrSessionUser, requiredPermissions) {
  const required = asArray(requiredPermissions)
  if (required.length === 0) return false

  const names = toPermissionNames(userOrSessionUser)
  return required.some((requiredPermission) =>
    names.includes(requiredPermission),
  )
}

export function isAdminLikeUser(userOrSessionUser) {
  return hasAnyPermission(userOrSessionUser, ADMIN_LIKE_PERMISSIONS)
}

export function normalizeUserPermissions(userOrSessionUser) {
  if (!userOrSessionUser || typeof userOrSessionUser !== 'object') {
    return { permissions: [] }
  }

  return {
    ...userOrSessionUser,
    permissions: Array.isArray(userOrSessionUser.permissions)
      ? userOrSessionUser.permissions
      : [],
  }
}
